import { render, staticRenderFns } from "./campCustomer.vue?vue&type=template&id=5b8e2dba&scoped=true&"
import script from "./campCustomer.vue?vue&type=script&lang=js&"
export * from "./campCustomer.vue?vue&type=script&lang=js&"
import style0 from "./campCustomer.vue?vue&type=style&index=0&id=5b8e2dba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8e2dba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b8e2dba')) {
      api.createRecord('5b8e2dba', component.options)
    } else {
      api.reload('5b8e2dba', component.options)
    }
    module.hot.accept("./campCustomer.vue?vue&type=template&id=5b8e2dba&scoped=true&", function () {
      api.rerender('5b8e2dba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/camp/campCustomer.vue"
export default component.exports